<template>
  <v-dialog v-model="show" max-width="700px" min-width="360px">
    <v-card>
      <v-card-title>
        {{ $t("explore.popup_dialog_title") }}
      </v-card-title>
      <v-card-text>
        {{ $t("explore.popup_dialog_text") }}
      </v-card-text>
      <v-card-actions>
        <v-col class="text-right">
          <v-btn @click="show = false">{{ $t("confirm_regis.close") }}</v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Popup",
  props: {},
  computed: {},
  data: () => ({
    show: true,
  }),
  created() {},
};
</script>
